import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DoneRoundLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "m5 14 3.233 2.425a1 1 0 0 0 1.374-.167L18 6" })));
}
const DoneRoundLight = forwardRef(_DoneRoundLight);
export { DoneRoundLight };
